import React, { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Login from './components/Login.jsx';
import Panel from './components/Panel.jsx';

function App() {
  const [loggedIn, setLoggedIn] = useState(null);

  useEffect(() => {
    fetch('/api/protected', { credentials: 'include' })
      .then(res => res.ok ? setLoggedIn(true) : setLoggedIn(false))
      .catch(() => setLoggedIn(false));
  }, []);

  if (loggedIn === null) {
    return <div>⏳ Session loading...</div>;
  }

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<Login onLogin={() => setLoggedIn(true)} />} />
        <Route
          path="/panel"
          element={loggedIn ? <Panel onLogout={() => setLoggedIn(false)} /> : <Navigate to="/login" />}
        />
        <Route path="*" element={<Navigate to={loggedIn ? "/panel" : "/login"} />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
